export enum TopIndicators {
  Allocation = 'allocation',
  CashReserve = 'cash-reserve',
  IdleDistribution = 'idle-distribution',
  Runway = 'runway',
}
